import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
@Component({
  selector: 'app-complaint-attendance',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './complaint-attendance.component.html',
  styleUrl: './complaint-attendance.component.scss'
})
export class ComplaintAttendanceComponent {

}
